import { ref } from 'vue'

export function useSwipeGesture(options = {}) {
  const {
    swipeThreshold = 50,
    minVelocity = 0.3,
    onSwipeLeft = () => {},
    onSwipeRight = () => {}
  } = options

  // Touch tracking state
  const touchStartX = ref(0)
  const touchStartY = ref(0)
  const touchEndX = ref(0)
  const touchEndY = ref(0)
  const touchStartTime = ref(0)
  const isSwiping = ref(false)

  const handleTouchStart = (e) => {
    if (!e.touches || !e.touches[0]) return
    
    touchStartX.value = e.touches[0].clientX
    touchStartY.value = e.touches[0].clientY
    touchEndX.value = e.touches[0].clientX
    touchEndY.value = e.touches[0].clientY
    touchStartTime.value = Date.now()
    isSwiping.value = true
  }

  const handleTouchMove = (e) => {
    if (!isSwiping.value || !e.touches || !e.touches[0]) return
    touchEndX.value = e.touches[0].clientX
    touchEndY.value = e.touches[0].clientY
  }

  const handleTouchEnd = () => {
    if (!isSwiping.value) return
    isSwiping.value = false

    const deltaX = touchEndX.value - touchStartX.value
    const deltaY = touchEndY.value - touchStartY.value
    const deltaTime = Date.now() - touchStartTime.value
    
    // Calculate velocity (pixels per millisecond)
    const velocity = Math.abs(deltaX) / deltaTime

    if (process.env.NODE_ENV === 'development') {
      console.log(`Swipe - X: ${deltaX}, Y: ${deltaY}, Time: ${deltaTime}ms, Velocity: ${velocity.toFixed(2)}px/ms`)
    }

    // Check if gesture meets all criteria
    const isHorizontalSwipe = Math.abs(deltaX) > Math.abs(deltaY)
    const meetsDistanceThreshold = Math.abs(deltaX) > swipeThreshold
    const meetsVelocityThreshold = velocity > minVelocity

    if (isHorizontalSwipe && meetsDistanceThreshold && meetsVelocityThreshold) {
      if (deltaX > 0) {
        onSwipeRight()
      } else {
        onSwipeLeft()
      }
    }

    // Reset coordinates
    resetTouchState()
  }

  const resetTouchState = () => {
    touchStartX.value = 0
    touchEndX.value = 0
    touchStartY.value = 0
    touchEndY.value = 0
    touchStartTime.value = 0
  }

  const cleanup = () => {
    resetTouchState()
    isSwiping.value = false
  }

  // Return touch event handlers and cleanup function
  return {
    handleTouchStart,
    handleTouchMove,
    handleTouchEnd,
    cleanup,
    isSwiping
  }
}